import PropTypes from "prop-types";

import ChallengesTeacherTopicCard from "./ChallengesTeacherTopicCard";
import {
  challengesListCss,
  challengesWrapper,
} from "./ChallengesTeacherTopicsList.style";

const topicType = {
  topic_id: PropTypes.string,
  title: PropTypes.string,
  image: {
    url: PropTypes.string,
    alt: PropTypes.string,
  },
  description: PropTypes.string,
  total_articles: PropTypes.number,
  total_activities: PropTypes.number,
  done_activities: PropTypes.number,
  total_standards: PropTypes.number,
  tokens: PropTypes.number,
  earned_tokens: PropTypes.number,
};

const propTypes = {
  topics: PropTypes.arrayOf(PropTypes.shape(topicType)),
};

const ChallengesTeacherTopicsList = ({ topics }) => {
  return (
    <div css={challengesWrapper}>
      <h3>Challenge Topics</h3>
      <div css={challengesListCss}>
        {topics?.map((topic) => (
          <ChallengesTeacherTopicCard key={Math.random()} topic={topic} />
        ))}
      </div>
    </div>
  );
};

ChallengesTeacherTopicsList.propTypes = propTypes;

export default ChallengesTeacherTopicsList;
